import { render, staticRenderFns } from "./Hotspot-label.vue?vue&type=template&id=0ff54af7&scoped=true"
import script from "./Hotspot-label.vue?vue&type=script&lang=js"
export * from "./Hotspot-label.vue?vue&type=script&lang=js"
import style0 from "./Hotspot-label.vue?vue&type=style&index=0&id=0ff54af7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff54af7",
  null
  
)

export default component.exports